import Tabs from 'react-bootstrap/Tabs';
import TabsDeprecated from './deprecated';

Tabs.Deprecated = TabsDeprecated;

export default Tabs;
export { default as Tab } from 'react-bootstrap/Tab';
export { default as TabContainer } from 'react-bootstrap/TabContainer';
export { default as TabContent } from 'react-bootstrap/TabContent';
export { default as TabPane } from 'react-bootstrap/TabPane';
